import React, { useContext } from 'react';
import { useHistory } from "react-router-dom";
import { Texture, Loader, TextStyle } from 'pixi.js'
import { Stage, Sprite, Container, AnimatedSprite, Text } from '@inlet/react-pixi'
import Slide from '@material-ui/core/Slide';
import Grid from '@material-ui/core/Grid';
import Snackbar from '@material-ui/core/Snackbar';

import HomeContext from '../../context/home-context';
import SnackbarMenu from './trait/SnackbarMenu'
import CloudAndSun from './IslandDecorationAssets/CloudAndSun'
import MoonAndCloud from './IslandDecorationAssets/MoonAndCloud'
import IslandDecoration from './IslandDecoration'
import Thunder from './IslandDecorationAssets/Thunder'
import Raining from './IslandDecorationAssets/Raining'
import MaxLevelEffect from './trait/MaxLevelEffect'
import TraitContainer from './trait/TraitContainer'
import ViewPort from '../shared/PixiViewPort'
import DailyChest from './chest/DailyChest'
import MonsterMenu from './monster/MonsterMenu'
import FlyingFoodAnimationModal from './chest/FlyingFoodAnimationModal'
import Monster from './IslandDecorationAssets/Monster'
import Plane from './IslandDecorationAssets/Plane'
import ChallengeJet from './IslandDecorationAssets/ChallengeJet'
import Rainbow from './IslandDecorationAssets/Rainbow'

import { HowlerUtils } from '../../utils/helpers/island/SoundHelper'

const domElement = document.querySelector('#root');
let initWidth = domElement.offsetWidth;
let initHeight = domElement.offsetHeight;
let islandTextures = [];
let starTextures = [];

const SlideTransition = (props) => <Slide {...props} direction="up" />;

const IslandHolder = () => {
    const history = useHistory();
    const loader = Loader.shared; // PixiJS exposes a premade instance for you to use.
    const [notiOpen, setNotiOpen] = React.useState(false);
    const titleStyle = new TextStyle({
        fontFamily: '"Source Sans Pro", Helvetica, sans-serif',
        fontSize: 24,
        fill: "white",
        wordWrap: true,
        wordWrapWidth: 250,
        align: "center",
    });

    const { homeContext, dispatch } = useContext(HomeContext);

    let xInitial = 0;
    let yInitial = 0;
    if (initWidth < 2000) {
        initWidth = 1920;
        initHeight = 900;
    }
    else {
        xInitial = (initWidth - 1920) / 2;
        yInitial = (initHeight - 900) / 2;
    }

    let roadTexture = loader.resources["./assets/images/components/island/spritesheets/skyAssets/text_sun_moon_road.json"].textures["road-05.png"];
    let seaTexture = loader.resources["./assets/images/components/island/spritesheets/seaAssets/sea_sparkle.json"].textures["sea-day_animated001.png"];
    let coinTexture = Texture.from(`./assets/images/components/island/particle/coin.png`);

    let drumstickTexture = loader.resources["./assets/images/components/island/spritesheets/seaAssets/sea_sparkle.json"].textures[`drumstick.png`];
    let berryTexture = loader.resources["./assets/images/components/island/spritesheets/seaAssets/sea_sparkle.json"].textures[`berry.png`];
    let newIslandTexture = loader.resources["./assets/images/components/island/spritesheets/seaAssets/sea_sparkle.json"].textures[`newIsland.png`];


    //for max level
    let learningMax = homeContext.learning.levelPercent >= 100 ? true : false;
    let mindsetMax = homeContext.mindset.levelPercent >= 100 ? true : false;
    let resilienceMax = homeContext.resilience.levelPercent >= 100 ? true : false;
    let wellbeingMax = homeContext.wellbeing.levelPercent >= 100 ? true : false;

    //change background
    let currentTime = new Date().getHours();
    //let currentTime = 20;
    if (currentTime >= 5 && currentTime <= 19) {
        //island
        for (let i = 1; i <= 12; i++) {
            islandTextures.push(loader.resources["./assets/images/components/island/spritesheets/dayOfTheIsland/island_day.json"].textures[`island_day_animated_000${i}.png`]);
        }
    }

    let backgroundPath = loader.resources["./assets/images/components/island/spritesheets/dayOfTheIsland/morningBG.json"].textures[`island__bg-morning.png`]; //morning

    if (currentTime >= 11 && currentTime < 16)
        backgroundPath = loader.resources["./assets/images/components/island/spritesheets/dayOfTheIsland/afternoonBG.json"].textures[`island_bg-afternoon.png`];//afternoon
    else if (currentTime >= 16 && currentTime <= 19)
        backgroundPath = loader.resources["./assets/images/components/island/spritesheets/dayOfTheIsland/eveningBG.json"].textures[`island_bg-evening.png`];//evening
    else if (currentTime > 19 || currentTime <= 4) {
        //night
        backgroundPath = loader.resources["./assets/images/components/island/spritesheets/dayOfTheIsland/nightBG.json"].textures[`island_bg-night.png`];
        newIslandTexture = loader.resources["./assets/images/components/island/spritesheets/seaAssets/sea_sparkle.json"].textures[`newIsland_night.png`];
        //stars
        for (let i = 1; i <= 6; i++) {
            starTextures.push(loader.resources["./assets/images/components/island/spritesheets/dayOfTheIsland/star1.json"].textures[`stars_animated00${i}.png`]);
        }

        //island night
        for (let i = 1; i <= 12; i++) {
            islandTextures.push(loader.resources["./assets/images/components/island/spritesheets/dayOfTheIsland/island_night.json"].textures[`island-night_animated000${i}.png`]);
        }

        //sea night
        seaTexture = loader.resources["./assets/images/components/island/spritesheets/seaAssets/sea_sparkle.json"].textures["SEA-night001.png"];
    }

    if (homeContext.weather === "weather rain" || homeContext.weather === "weather thunder")
        backgroundPath = loader.resources["./assets/images/components/island/spritesheets/dayOfTheIsland/rainingBG.json"].textures[`island_bg-raining.png`];

    let decoration = currentTime >= 5 && currentTime <= 19 ? <CloudAndSun /> : <MoonAndCloud />;

    const handleClose = () => {
        HowlerUtils.playSound('close');
        dispatch({ type: 'SET_SNACKBAR_MENU', snackbarMenu: { open: false, levelpercent: 0 } });
    };

    const monsterMenuClose = () => {
        HowlerUtils.stopSound('jungle');
        HowlerUtils.playSound('home');
        homeContext.monsterMenu.open = false;
        dispatch({ type: 'SET_MONSTER_MENU', monsterMenu: homeContext.monsterMenu });
    };

    const monsterMenuOpen = () => {
        HowlerUtils.stopSound('home');
        HowlerUtils.playSound('jungle');
        homeContext.monsterMenu.open = true;
        dispatch({ type: 'SET_MONSTER_MENU', monsterMenu: homeContext.monsterMenu });
    };

    const handleClick = (value) => {
        if (homeContext.snackbarMenu.open && homeContext.snackbarMenu.title === value.name) {
            HowlerUtils.playSound('close');
            dispatch({
                type: 'SET_SNACKBAR_MENU', snackbarMenu: {
                    open: false, title: value.name, recommendation: value.recommendedAmount,
                    leveltext: value.levelString, levelpercent: value.levelPercent,
                    traitid: value.id, transition: SlideTransition
                }
            });
        }
        else {
            HowlerUtils.playSound('open');
            dispatch({
                type: 'SET_SNACKBAR_MENU', snackbarMenu: {
                    open: true, title: value.name, recommendation: value.recommendedAmount,
                    leveltext: value.levelString, levelpercent: value.levelPercent,
                    traitid: value.id, transition: SlideTransition
                }
            });
        }
    }

    const goToSurvey = () => history.push("/Survey");

    const goToChallenge = () => history.push("/Challenge");

    const goToShop = () => history.push("/RewardShop");

    const notiCloseClick = () => setNotiOpen(false);

    const notiOpenClick = () => setNotiOpen(true);

    return (
        <div>
            <div>
                <div className={homeContext.monsterMenu.monsterLvl > 0 ?
                    homeContext.monsterMenu.moodMeter < 50 ? `adventurelearn_monsterIcon ${homeContext.monsterMenu.cluster} sad`
                        : `adventurelearn_monsterIcon ${homeContext.monsterMenu.cluster}`
                    : `adventurelearn_eggIcon ${homeContext.monsterMenu.cluster}`}>
                    <span onClick={monsterMenuOpen}>
                        <i></i>
                    </span>
                </div>
            </div>
            {
                homeContext &&
                <HomeContext.Provider value={{ homeContext, handleClick, handleClose, dispatch, monsterMenuClose, monsterMenuOpen, notiOpenClick }}>
                    <div className={homeContext.weather}>
                        <Grid container>
                            <Stage width={initWidth} height={initHeight} options={{ backgroundColor: 0x006994 }}>
                                <ViewPort>
                                    <HomeContext.Provider value={{ homeContext, handleClick, goToSurvey, dispatch, monsterMenuOpen, notiOpenClick }}>

                                        <Sprite width={initWidth} height={initHeight} texture={backgroundPath} />
                                        {
                                            homeContext.dailyChestClaim.onGoingCampaignCount > 0 ?
                                                <Rainbow route={goToShop} /> : <Container />
                                        }

                                        <Container width={initWidth} height={initHeight}>
                                            {
                                                currentTime > 19 || currentTime <= 4 ? <AnimatedSprite
                                                    textures={starTextures}
                                                    isPlaying={true}
                                                    initialFrame={0}
                                                    animationSpeed={0.1} scale={{ x: 1.8, y: 1.8 }}
                                                /> : <Container />
                                            }
                                        </Container>
                                        <Container>
                                            <Sprite
                                                scale={{ x: 0.6, y: 0.6 }}
                                                x={10}
                                                y={10}
                                                texture={coinTexture}
                                            />
                                            <Text
                                                text={homeContext.dailyChestClaim.coins}
                                                x={80}
                                                y={30}
                                                style={titleStyle}
                                            />
                                            <Sprite
                                                scale={{ x: 0.2, y: 0.2 }}
                                                x={5}
                                                y={85}
                                                texture={homeContext.monsterMenu.cluster === "ENG" || homeContext.monsterMenu.cluster === "CEFT" ? berryTexture : drumstickTexture}
                                            />
                                            <Text
                                                text={homeContext.dailyChestClaim.foodCount}
                                                x={80}
                                                y={100}
                                                style={titleStyle}
                                            />
                                        </Container>
                                        <Container x={xInitial} y={yInitial}>
                                            <Sprite
                                                y={-150}
                                                texture={seaTexture}
                                                scale={{ x: 1.9, y: 1.9 }}
                                            />
                                            <Container y={50}>
                                                <Container x={400} y={600}>
                                                    <Sprite
                                                        x={-20} y={10}
                                                        texture={newIslandTexture}
                                                    />
                                                    {
                                                        homeContext.monsterMenu.monsterLvl > 0 ?
                                                            <DailyChest />
                                                            : <Container></Container>
                                                    }
                                                </Container>
                                                <AnimatedSprite
                                                    textures={islandTextures}
                                                    isPlaying={true}
                                                    initialFrame={0}
                                                    x={620} y={240}
                                                    scale={{ x: 1.2, y: 1.2 }}
                                                    animationSpeed={0.3}
                                                />
                                                <Sprite texture={roadTexture} x={780} y={290} scale={{ x: 0.6, y: 0.6 }} />
                                                <IslandDecoration />
                                                <TraitContainer />
                                                <Monster />
                                                <MaxLevelEffect xPos={900} yPos={290} isVisible={learningMax} />
                                                <MaxLevelEffect xPos={760} yPos={370} isVisible={mindsetMax} />
                                                <MaxLevelEffect xPos={750} yPos={170} isVisible={wellbeingMax} />
                                                <MaxLevelEffect xPos={630} yPos={270} isVisible={resilienceMax} />
                                                {
                                                    homeContext.dailyChestClaim.onGoingSurveyCount > 0 ?
                                                        <Plane _xPos={50} _yPos={140} speed={0.01} max={800} min={0} route={goToSurvey} isSurvey={true} /> : <Container />
                                                }
                                                {
                                                    homeContext.dailyChestClaim.onGoingChallengeCount > 0 ?
                                                        <ChallengeJet _xPos={initWidth - 220} _yPos={0} speed={0.08} _yMax={initHeight - 100} _xMax={10} route={goToChallenge} /> : <Container />
                                                }
                                                {
                                                    (homeContext.weather === "weather default") ? decoration : <Container />
                                                }
                                                {
                                                    (homeContext.weather === "weather thunder") ? <Thunder /> : <Container />
                                                }
                                                {
                                                    (homeContext.weather === "weather rain") ? <Raining /> : <Container />
                                                }
                                            </Container>
                                        </Container>
                                        <FlyingFoodAnimationModal _isOpen={notiOpen} _notiCloseClick={notiCloseClick} />
                                    </HomeContext.Provider>
                                </ViewPort>
                            </Stage>
                            <SnackbarMenu />
                            <MonsterMenu />
                            <Snackbar
                                anchorOrigin={{ vertical: 'bottom', horizontal: 'left', }}
                                open={homeContext.monsterMenu.isMissing}
                                message="Your dinosaur is missing! Please check dinosaur place to find out what is going on!"
                            />
                        </Grid>
                    </div>
                </HomeContext.Provider>
            }
        </div>
    );
}

export { IslandHolder as default }

//<Container x={1200} y={700}>
//    <RocketStation />
//</Container>